import { Stack, type StackProps, useMediaQuery } from '@mui/material';
import { SwitchLanguage } from '../../biz/switch-lang';
import { MySvgIcon } from '../../ui/svg-icon';

export const Logo: React.FC<StackProps> = (props) => {
  const isDownMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

  return (
    <Stack direction="row" justifyContent="space-between" spacing={2} className="w-full" {...props}>
      <MySvgIcon name="logo" aria-hidden="true" width={109 * 1.35} height={37 * 1.35} />
      {isDownMd && <SwitchLanguage />}
    </Stack>
  );
};
